
import * as R from 'ramda'
import { call, reducer } from '../../../helpers/api/meta'
import { getCourseDiscussion } from '../../../helpers/api/api';

export const GET_COURSE_DISCUSSION = 'GET_COURSE_DISCUSSION'

export const callGetCourseDiscussion = (inputs) => {
    const meta = {
        endpoint: (params) => getCourseDiscussion(params),
        inputs,
        action: GET_COURSE_DISCUSSION,
        messages: {
            id: 'getCourseDiscussion',
            failure: 'Could not get course discussion'
        }
    }
    return call(meta)
}

const initialState = {
    loading: false,
    discussion: {}
}

const saveCourseDiscussion = (state, action) => {
    return R.assoc('results', action.results, state);
}

const messages = {
    loadFailed: 'Could not load courses.',
}

export default reducer(initialState, GET_COURSE_DISCUSSION, saveCourseDiscussion, messages.loadFailed)